<template>
  <div>
    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="formData.legalInfo.document"
          label="Documento"
          outlined
          dense
          @input="formatCNPJ"
          :rules="[rules.required, rules.cnpj]"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="formData.legalInfo.legalName"
          label="Razão Social"
          outlined
          dense
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="formData.legalInfo.fantasyName"
          label="Nome Fantasia"
          outlined
          dense
        />
      </v-col>
    </v-row>

    <slot name="actions"></slot>
  </div>
</template>

<script>
export default {
  name: "LegalInfoStep",
  props: {
    value: {
      type: Object,
      required: true,
    },
    oldValue: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    rules: {
      required: (v) => !!v || "Campo obrigatório",
      cnpj: (v) => {
        const pattern = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;
        if (!pattern.test(v)) return "CNPJ inválido";
        // ... resto da validação do CNPJ ...
        return true;
      },
    },
  }),
  computed: {
    hasChanges() {
      if (this.oldValue.legalInfo.document !== this.formData.legalInfo.document)
        return true;
      if (
        this.oldValue.legalInfo.legalName !== this.formData.legalInfo.legalName
      )
        return true;
      if (
        this.oldValue.legalInfo.fantasyName !==
        this.formData.legalInfo.fantasyName
      )
        return true;

      return false;
    },

    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    getFormData() {
      if (!this.hasChanges) return false;
      return {
        legalInfo: this.formData.legalInfo,
      };
    },
    initFormData() {
      this.formData.legalInfo = {
        document: this.oldValue.legalInfo.document || null,
        legalName: this.oldValue.legalInfo.legalName || null,
        fantasyName: this.oldValue.legalInfo.fantasyName || null,
      };
    },
    // TODO: Remover essa função e usar o componente de input com mask
    formatCNPJ(value) {
      if (!value) return "";
      value = value.replace(/\D/g, "");
      if (value.length > 14) value = value.slice(0, 14);

      if (value.length > 12) {
        this.formData.legalInfo.document = `${value.slice(0, 2)}.${value.slice(
          2,
          5
        )}.${value.slice(5, 8)}/${value.slice(8, 12)}-${value.slice(12)}`;
      } else if (value.length > 8) {
        this.formData.legalInfo.document = `${value.slice(0, 2)}.${value.slice(
          2,
          5
        )}.${value.slice(5, 8)}/${value.slice(8)}`;
      } else if (value.length > 5) {
        this.formData.legalInfo.document = `${value.slice(0, 2)}.${value.slice(
          2,
          5
        )}.${value.slice(5)}`;
      } else if (value.length > 2) {
        this.formData.legalInfo.document = `${value.slice(0, 2)}.${value.slice(
          2
        )}`;
      } else {
        this.formData.legalInfo.document = value;
      }
    },
  },
  mounted() {
    this.initFormData();
  },
};
</script>
